<template>
  <video :id="'remoteVideo_'+this.peerUuid" ref="remoteVideo" autoplay playsinline></video>
</template>

<script>
export default {
  name: "VideoBox",
  components: {
  },
  props:['peerUuid','mediaStream'],
  data() {
    return {
      remoteVideo: undefined
    }
  },
  mounted() {
    this.remoteVideo = this.$refs.remoteVideo;
    if('srcObject' in this.remoteVideo) {
        this.remoteVideo.srcObject = this.mediaStream;
      } else {
        this.remoteVideo.src = window.URL.createObjectURL(this.mediaStream); /* fallback for old browsers */
      }
  }
}
</script>
